import { doc, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore';

import { firestore } from '../firebase';
import Person from '../types/Person';
import PersonDetails from '../types/PersonDetails';

export const usePersonMutators = () => {
  const updatePerson = async (person: Partial<Person>): Promise<void> => {
    if (!person.itemId) {
      console.error('Person itemId not found');
      return;
    }

    try {
      const { itemId: _itemId, ...updates } = person;
      const profileDoc = doc(firestore, 'profile', person.itemId!);
      await setDoc(profileDoc, { ...updates }, { merge: true });
    } catch (error) {
      console.error('Error updating profile document:', error);
    }
  };

  const updatePersonDetails = async (details: Partial<PersonDetails>): Promise<void> => {
    if (!details.itemId) {
      console.error('PersonDetails itemId not found');
      return;
    }

    try {
      const { itemId, ...updates } = details;
      const personDetailsRef = doc(firestore, 'profile', itemId, 'details', itemId);
      // Remove undefined values to prevent Firestore errors
      const cleanedDetails = JSON.parse(JSON.stringify(updates));
      await updateDoc(personDetailsRef, cleanedDetails);
    } catch (error) {
      console.log("details: ", details);
      console.error('Error updating person details:', error);
    }
  };

  /** Asks the server to connect the person to their USGA scoring record (handleProfileUsgaConnectRequested). */
  const requestUsgaConnect = async (personId: string): Promise<void> => {
    await updateDoc(doc(firestore, 'profile', personId, 'details', personId), { usgaConnectRequestedAt: serverTimestamp() });
  };

  return {
    updatePerson,
    updatePersonDetails,
    requestUsgaConnect,
  };
};